import { setDialog, useStore, DIALOG } from '../store';
import i18n from '../i18n';
import { track } from './track';

export function useDialog(dialog) {
  const [_dialog, setDialog] = useStore(DIALOG);

  const openDialog = (__dialog) => {
    setDialog(__dialog || dialog);
  };

  const closeDialog = () => {
    setDialog(null);
  };

  return { dialog: _dialog, openDialog, closeDialog };
}

/*
  onClose
  actions
  open
  title
  content
*/
export function confirmDialog(dialog) {
  return new Promise((resolve, reject) => {
    setDialog({
      ...dialog,
      open: true,
      actions: [
        {
          label: dialog.cancelText || i18n.t('Avbryt'),
          onClick: () => {
            resolve(false);
            setDialog(null);
          },
        },
        {
          label: dialog.confirmText || i18n.t('Bekräfta'),
          onClick: () => {
            resolve(true);
            setDialog(null);
          },
        },
      ],
    });
  });
}

export function alertDialog(dialog) {
  return new Promise((resolve, reject) => {
    setDialog({
      ...dialog,
      open: true,
      actions: [
        {
          label: i18n.t('Ok'),
          onClick: () => {
            resolve(true);
            setDialog(null);
          },
        },
      ],
    });
  });
}

export function promptDialog(dialog) {
  return new Promise((resolve, reject) => {
    setDialog({
      ...dialog,
      type: 'prompt',
      open: true,
      actions: [
        {
          label: i18n.t('Avbryt'),
          onClick: () => {
            resolve(null);
            setDialog(null);
          },
        },
        {
          label: i18n.t('Spara'),
          onClick: (value) => {
            resolve(value);
            setDialog(null);
          },
        },
      ],
    });
  });
}

export function showTemplateDialog(type, data = {}) {
  return new Promise((resolve, reject) => {
    track('show_template_dialog', { type });
    setDialog({
      open: true,
      type,
      data,
      onClose: (val) => {
        resolve(val);
        setDialog(null);
      },
    });
  });
}
